import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'sonner';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import Footer from './components/Footer';
import Landing from './pages/Landing';
import Support from './pages/Support';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import './App.css';

function AppShell() {
  return (
    <LanguageProvider>
      <div className="app-wrapper">
        <Header />
        <Routes>
          {/* English (default) */}
          <Route path="/" element={<Landing />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />

          {/* Spanish (/es prefix) */}
          <Route path="/es" element={<Landing />} />
          <Route path="/es/support" element={<Support />} />
          <Route path="/es/privacy" element={<Privacy />} />
          <Route path="/es/terms" element={<Terms />} />
        </Routes>
        <Footer />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: '#0A0A0A',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#F5F5F5',
              fontFamily: 'Figtree, sans-serif',
            },
          }}
        />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <HelmetProvider>
      <Router>
        <AppShell />
      </Router>
    </HelmetProvider>
  );
}

export default App;
